"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextZone = exports.Zones = void 0;
var Zones;
(function (Zones) {
    Zones["ATTACK"] = "ATTACK";
    Zones["MIDFIELD"] = "MIDFIELD";
    Zones["DEFENSE"] = "DEFENSE";
})(Zones || (exports.Zones = Zones = {}));
const getNextZone = (curentZone) => {
    return curentZone === Zones.DEFENSE ? Zones.MIDFIELD : Zones.ATTACK;
};
exports.getNextZone = getNextZone;
